module.exports = __webpack_public_path__ + "static/images/containers/Stronghold/components/Direction/components/Building/images/artillery-battalion-lvl2-100.e3cf87e4.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Stronghold/components/Direction/components/Building/images/artillery-battalion-lvl2-100.png
// module id = 3282
// module chunks = 11